module.exports = __webpack_public_path__ + "static/media/rom13.b316f1af.jpg";